<template>
  <flash-modal
    id="flash-modal-success"
    type="success"
  />
</template>

<script>
  import FlashModal from '@/components/modals/FlashModal'

  export default {
    name: 'SuccessFlashModal',
    components: {
      FlashModal
    }
  }
</script>
